import type { CreateItemRequest, Item, UpdateItemRequest } from "@template/types";
import { apiClient } from "./client/api-client";

export const itemsApi = {
  list: () => apiClient.get<Item[]>("/items"),

  get: (id: string) => apiClient.get<Item>(`/items/${id}`),

  create: (payload: CreateItemRequest) => apiClient.post<Item>("/items", payload),

  update: (id: string, payload: UpdateItemRequest) =>
    apiClient.patch<Item>(`/items/${id}`, payload),

  remove: (id: string) => apiClient.delete<void>(`/items/${id}`),
};
